module.exports = __webpack_public_path__ + "img/hr.b6d03cc6.svg";